import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';
import { ApolloProvider } from "@apollo/client";
import Theme from "./Theme";
import { Page, StartPage, SearchPage } from "./Page";
import BusinessPage from "./Business/BusinessPage";
import RentPage from "./Business/RentPage";

import ScrollToTop from "./UI/Helpers";
import { NewsList, NewsPost } from "./News";
import { Footer } from "./Footer";
import { Header } from "./Header";
import "./App.css";

// const graph_uri =
//   process.env.NODE_ENV === "development"
//     ? "http://localhost:8000/graphql"
//     : "https://api.orvelinfastigheter.se/graphql";

const graph_uri = "https://api.orvelinfastigheter.se/graphql";

// Updated Apollo Client v3 setup
const httpLink = new HttpLink({
  uri: graph_uri,
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

const NoMatch = () => (
  <div>
    <h3>Hoppsan... Sidan hittades inte.</h3>
  </div>
);

function App() {
  return (
    <ApolloProvider client={client}>
      <Router>
        <ScrollToTop>
          <Theme>
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<StartPage />} />
                <Route path="/nyheter" element={<NewsList />} />
                <Route path="/nyheter/:slug" element={<NewsPost />} />
                <Route path="/lediga-objekt/:slug" element={<RentPage />} />
                <Route path="/fastighet/:slug" element={<BusinessPage />} />
                <Route
                  path="/sokresultat/:searchTerm"
                  element={<SearchPage />}
                />
                <Route path="/:slug" element={<Page />} />
                <Route path="*" element={<NoMatch />} />
              </Routes>
            </main>
            <Footer />
          </Theme>
        </ScrollToTop>
      </Router>
    </ApolloProvider>
  );
}

export default App;
